/**
 * Profile. Spec 12.1's player profile screen, plus the device controls spec 10.9 requires.
 * Two-factor enrolment (spec 10.3) moved to Studio settings — see `MfaCard`.
 */
import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { useIdentity } from '../../../features/auth/useAuth';
import { ProfilePage } from '../../../features/profile/ProfilePage';

export const Route = createFileRoute('/$lang/app/profile')({ component: Page });

function Page(): ReactNode {
  const { lang } = Route.useParams();
  const { identity } = useIdentity();

  /* The `/app` guard guarantees a non-guest identity; this satisfies the type, not the logic. */
  if (identity === null) return null;

  return <ProfilePage identity={identity} lang={lang} />;
}
